var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4974 2.5H17.4974C17.7184 2.5 17.9304 2.5878 18.0867 2.74408C18.2429 2.90036 18.3307 3.11232 18.3307 3.33333V16.6667C18.3307 16.8877 18.2429 17.0996 18.0867 17.2559C17.9304 17.4122 17.7184 17.5 17.4974 17.5H2.4974C2.27638 17.5 2.06442 17.4122 1.90814 17.2559C1.75186 17.0996 1.66406 16.8877 1.66406 16.6667V3.33333C1.66406 3.11232 1.75186 2.90036 1.90814 2.74408C2.06442 2.5878 2.27638 2.5 2.4974 2.5ZM16.6641 6.03167L10.0574 11.9483L3.33073 6.01333V15.8333H16.6641V6.03167ZM3.75656 4.16667L10.0482 9.71833L16.2491 4.16667H3.75656Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.7358c89bf1a5e0a1c5f3c21e00706469.svg";
export { ForwardRef as ReactComponent };